module.exports = __webpack_public_path__ + "static/media/banner.423c361d.png";